export const incidentProgress = {
  open: "Registrada", in_progress: "En gestión", waiting_sifen: "Esperando a SIFEN",
  resolved: "Resuelta", closed: "Cerrada",
};
export const incidentDelivery = {
  queued: "Envío programado", sending: "Enviando", sent: "Correo enviado",
  failed: "Error de envío", cancelled: "Envío cancelado",
};

export interface SifenIncident {
  id: number;
  taxPayerId: number;
  taxPayerName: string;
  taxPayerRuc: string;
  documentNumber: string;
  cdc: string;
  issueLabel: string;
  progressStatus: keyof typeof incidentProgress;
  deliveryStatus: keyof typeof incidentDelivery;
  requestedByName: string;
  attemptCount: number;
  supportTicket: string | null;
  nextAttemptAt: string | null;
  sentAt: string | null;
  lastError: string | null;
  createdAt: string;
  details: string;
  canSendEmail?: boolean;
  originalMessage?: { subject: string; text: string; to?: string; cc?: string[] };
  snapshot?: {
    mail: { to: string; cc: string[]; replyTo: string; subject: string; text: string };
    attachments: { filename: string }[];
  };
  events?: { id: number; kind?: string; authorName: string; note: string; emailHtml?: string | null; createdAt: string }[];
}
